export default "/images/4e4c9aff82b46ffdaf3ffb188919fded.avif";